const OIDC_CLIENT_STORAGE_PREFIX = "oidc.";

/** Clears oidc-client-ts session keys (stored user and in-flight login state). */
export const clearCognitoOAuthClientStorage = (): void => {
  const keysToRemove: string[] = [];
  for (let i = 0; i < sessionStorage.length; i += 1) {
    const key = sessionStorage.key(i);
    if (key != null && key.startsWith(OIDC_CLIENT_STORAGE_PREFIX)) {
      keysToRemove.push(key);
    }
  }
  for (const key of keysToRemove) {
    sessionStorage.removeItem(key);
  }
};
